import { ViewSupport4Container } from "../../../containers/SupportSystem/ViewReports/ViewSupport4Container"
export function ViewSupport4Page() {
    return (
        <ViewSupport4Container />
    )
}